import {Component, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {FormGroup, NgForm, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {forkJoin} from 'rxjs';
//generic
import {NgSelectComponent} from '@ng-select/ng-select';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {Subject} from 'rxjs';
import {TrankInvitationsDetailsService} from './trackInvitationsDetails.service';

@Component({
  selector: 'trackInvitationsDetails',
  templateUrl: './trackInvitationsDetails.component.html',
  providers: [TrankInvitationsDetailsService],
})
export class TrackInvitationsDetails extends BaseGridNoCookieComponent<TrankInvitationsDetailsService> {
  @ViewChild('myForm') myForm: NgForm;
  @ViewChild('myForm1') myForm1: NgForm;
  public ngUnsubscribe: Subject<void> = new Subject<void>();
  public submiting: boolean = false;
  public somth: boolean = true;
  public statusList = [];
  public statusListAlt = [];
  public actionsflow = [];
  public invId: any;
  public isClient: any;
  editForm: any;
  clientForm: UntypedFormArray;
  legalDocument: any;
  questionsClient: any;
  public invData: any;
  public bankList = [];
  public clientBranches = [];
  public bankBranchList = [];
  public docsList = [];
  public groupDocsList = [];
  public viewRole = this.securityService.isOtherStaff() || this.securityService.isAdmin();
  action: any;
  typeOfDoc: any;
  formCd: any;
  public initialCheck: boolean;
  kycDocument: [];
  auditList: [];
  isClientId: string;
  public activeTab = 1;
  private statusInv;
  submittingClient: boolean;
  form: any;
  options: FormlyFormOptions = {};
  model;
  termsTemplate: any;
  fields: FormlyFieldConfig[];
  form2: any;
  model2 = {documentList: []};
  fields2: any[];
  sizeOfCompany = [];
  sizeTicket = [];
  arrfeef = [];
  documentList = [];
  userId: any;
  isOrigin: any;
  loading: boolean = false;
  loadingDocuments: boolean = false;
  @ViewChildren('ngSelect') viewChildren: QueryList<NgSelectComponent>;
  cifObject: any;

  constructor(
    public gridService: TrankInvitationsDetailsService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    public fb: UntypedFormBuilder,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    super(securityService, logger, visualsService, gridService, 'trackInvitations');
    this.group = 'invitationDetails';
    this.userId = localStorage.getItem('invId');
    this.isClient = localStorage.getItem('isClient');
    this.getFormConfigAndData();
    this.getFlow(this.userId);
    this.loadVisuals();
    this.getIsNotLookUpList();
    this.eventsEmitterService.languageChange.subscribe({
      next: () => {
        this.loadVisuals();
        this.getIsNotLookUpList();
        let formFields = JSON.parse(localStorage.getItem('formlyForm'));
        this.model = Object.assign({}, ...this.form.getRawValue());
        this.fields = Object.assign([], this.mapFields(formFields).fields);
        this.getDocumentList(this.userId);
      },
    });
  }

  getIsNotLookUpList() {
    this.statusList = this.visualsService.getLkpFromStorageAsJSON('LKP_REG_USER_S_STATUS', true);
    this.statusListAlt = this.visualsService.getLkpFromStorageAsJSON('LKP_REG_USER_ALT_S_STATUS', true);
    this.docsList = this.visualsService.getLkpFromStorageAsJSON(
      'LKP_REGCMP_DOCUMENT_I_DOC_ID',
      true,
    );
    this.groupDocsList = this.visualsService.getLkpFromStorageAsJSON(
      'LKP_CMP_DOC_GROUP_GENERAL_DOC_TYPE',
      true,
    );
  }

  getFlow(id) {
    this.gridService.getFlow(id).subscribe({
      next: (actionsflow) => {
        this.actionsflow = actionsflow;
      },
    });
  }

  getFormConfigAndData() {
    this.loading = true;
    forkJoin([
      this.gridService.getFields(this.userId),
      this.gridService.loadBean(this.userId),
      this.gridService.getBanks(),
      this.gridService.getClientBranches(),
      this.gridService.getBankBranches(),
    ]).subscribe({
      next: (response) => {
        const arrayToObject = JSON.parse(response[1].data.dataChar);
        this.model = Object.assign({}, ...arrayToObject);
        this.bankList = response[2].data;
        this.clientBranches = response[3].data;
        this.bankBranchList = response[4].data;
        localStorage.setItem('formlyForm', response[0].data.valForm);
        this.fields = this.mapFields(JSON.parse(response[0].data.valForm)).fields;
        this.form = new UntypedFormArray(this.fields.map(() => new UntypedFormGroup({})));
        this.getDocumentList(this.userId);
        this.getAuditList();
        this.loading = false;
      },
      error: (error) => console.log('Error: ', error),
    });
  }

  getDocumentList(id: number) {
    this.loadingDocuments = true;
    this.gridService.getDocumentList(id, this.model.isAdmin ?? 'N').subscribe({
      next: (res) => {
        this.documentList = res.data;
        this.documentList.forEach((docItem) => {
          docItem.regCmpDocumentisValid = docItem.regCmpDocumentisValid == 'Y';
        });

        this.model2 = {
          ...this.model2,
          documentList: this.documentList,
        };
        this.fields2 = [
          {
            fields: [
              {
                fieldGroupClassName: 'row',
                wrappers: ['panel'],
                resetOnHide: false,
                props: {
                  label: 'Business Documentation',
                  options: this.docsList,
                },
                type: 'repeat',
                key: 'documentList',
                fieldArray: {
                  fieldGroup: [
                    {
                      className: 'col-6',
                      fieldGroupClassName: 'row',
                      fieldGroupName: '',
                      fieldGroup: [
                        {key: 'isLocked'},
                        {
                          key: 'regCmpDocumentisValid',
                          className: 'col-12 document-list',
                          type: 'checkbox',
                          resetOnHide: false,
                          props: {
                            change: (field, $event) => {},
                          },
                          hideExpression: '!model.fileName',
                        },
                        {
                          key: 'fileName',
                          className: 'col-12',
                          type: 'input',
                          resetOnHide: false,
                          props: {
                            disabled: true,
                            options: this.docsList,
                            actionsflow: this.actionsflow.length > 0,
                            status: this.model.status,
                          },
                          expressionProperties: {
                            type: 'model.fileName?"input":"file"',
                          },
                        },
                        {
                          key: 'regCmpDocumentComment',
                          className: 'col-12',
                          type: 'input',
                          resetOnHide: false,
                          props: {
                            required: true,
                          },
                          expressionProperties: {
                            'model.regCmpDocumentComment':
                              'model.regCmpDocumentisValid?"": model.regCmpDocumentComment',
                            'props.disabled': 'model.regCmpDocumentisValid? true: false',
                          },
                          hideExpression: '!model.fileName',
                        },
                        {
                          key: 'regCmpDocId',
                          type: 'button',
                          resetOnHide: false,
                          props: {
                            text: 'DOWNLOAD DOCUMENT',
                            actionsflow: true,
                            class: 'btn btn-primary ml-1',
                            onClick: ($event, file) => this.download($event, file),
                          },
                          hideExpression: '!model.fileName',
                        },
                        {
                          key: 'regCmpDocId',
                          type: 'button',
                          resetOnHide: false,
                          props: {
                            class: 'btn btn-danger ml-1',
                            text: 'DELETE DOCUMENT',
                            actionsflow: this.actionsflow.length > 0,
                            status: this.model.status,
                            onClick: ($event, file) => this.deleteDocument($event, file),
                          },
                          hideExpression: 'model.isLocked !=0',
                        },
                      ],
                    },
                  ],
                },
              },
            ],
          },
        ];
        this.loadingDocuments = false;
        this.form2 = new UntypedFormArray(this.fields2.map(() => new UntypedFormGroup({})));
        this.loading = false;
      },
      error: () => {
        this.loadingDocuments = false;
      },
    });
  }

  deleteDocument(regcmpdocId: number, file) {
    if (this.viewRole) {
      LogService.emitAlert({
        type: 'danger',
        body: 'You are not authorized to preform this action',
      });
      return;
    }
    this.gridService.deleteFile(regcmpdocId).subscribe({
      next: () => {
        this.getDocumentList(this.userId);
        LogService.emitAlert({
          type: 'success',
          body: 'Success',
        });
        this.logger.log('deleted file');
      },
      error: () => {
        LogService.emitAlert({
          type: 'danger',
          body: 'Success',
        });
        this.logger.log('Error deleting file');
      },
    });
  }

  onValueChanged() {
    // this.form2['controls'].forEach((item) => {
    //   if (item['controls'].regCmpDocumentisValid.value == true) {
    //     item.controls.regCmpDocumentComment.disable();
    //   } else {
    //     item.controls.regCmpDocumentComment.enable();
    //   }
    // });
  }

  submitForm(status) {
    this.statusInv = status;
    this.form.markAllAsTouched();
    this.form2.markAllAsTouched();
    if (status === 'ACC') {
      let numOfInvalidFields = this.getAllInvalidFields().length;
      if (numOfInvalidFields > 0) {
        //stop submit
        LogService.emitAlert({
          type: 'warning',
          body:
            this.visuals['numOfInvalidFieldsPrefix'] +
            numOfInvalidFields +
            this.visuals['numOfInvalidFieldsSuffix'],
        });
        return;
      }
    }
    this.submit(status);
  }

  getAllInvalidFields() {
    let inValidFields = [];
    this.runFunctionForEachField(this.form.getRawValue(), this.pushInvalidFields, inValidFields);
    this.runFunctionForEachField(
      this.form2.getRawValue()[0],
      this.pushInvalidFields,
      inValidFields,
    );
    return inValidFields;
  }

  runFunctionForEachField(fields: any[], func: Function, list: any[]) {
    return fields.map((fl) => {
      this.loopFieldGroups(fl, func, list);
    });
  }

  loopFieldGroups(formObj: any, func: Function, list: any[]) {
    Object.keys(formObj).map((formKey) => {
      if (Array.isArray(formObj[formKey])) {
        formObj[formKey].map((arrayItem) => {
          this.loopFieldGroups(arrayItem, func, list);
        });
      } else {
        func(formKey, list, formObj);
      }
    });
  }

  pushInvalidFields(field: any, list: any[], formObj: any) {
    if (field.includes('IsValid') || field.includes('isValid')) {
      if (!formObj[field]) {
        list.push(field);
      }
    }
  }

  submit(status) {
    if (this.form.invalid || this.form2.invalid) return;
    let formToSend = this.form.getRawValue();
    let formToSend2 = this.form2.getRawValue();
    var arr = [];
    formToSend2[0].forEach((v) => {
      v.regCmpDocumentisValid = v.regCmpDocumentisValid ? 'Y' : 'N';
      arr = [...arr, v];
    });
    formToSend.splice(-1, 1);
    this.loading = true;
    if (status == '') {
      formToSend[0].status = this.model.status;
      forkJoin([
        this.gridService.save(formToSend, this.userId),
        this.gridService.saveDocs(arr),
      ]).subscribe({
        next: () => {
          LogService.emitAlert({
            type: 'success',
            body: 'Success',
          });
          this.loading = false;
        },
      });
    } else {
      Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup && control.controls['status']) {
          control.controls['status'].setValue(status, { emitEvent: false });
        }
      });
      let formToSend = this.form.getRawValue();
      formToSend.splice(-1, 1);
      forkJoin([
        this.gridService.saveDocs(arr),
        this.gridService.changeStatus(formToSend, this.userId, status),
      ]).subscribe({
        next: () => {
          this.getFormConfigAndData();
          this.form.controls[0].controls.status.setValue(status);
          this.getFlow(this.userId);
          LogService.emitAlert({
            type: 'success',
            body: 'Success',
          });
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
    }
  }

  validAll(bool) {
    let formToSend = this.form.getRawValue();
    this.form.controls.map((tt) => {
      Object.keys(tt.controls).map((rr) => {
        if (tt.controls[rr]['controls']) {
          tt.controls[rr]['controls'].map((mm, index) => {
            Object.keys(mm.controls).map((uu, i) => {
              if (uu.includes('IsValid') || uu.includes('isValid')) {
                mm.controls[uu].setValue(bool);
                this.model[rr][index][uu] = bool;
              }
            });
          });
        } else {
          formToSend.map((o) => {
            Object.keys(o).map((r) => {
              if (r.includes('IsValid')) {
                this.model[r] = bool;
              }
            });
          });
        }
      });
    });
    let formToSendDocuments = this.form2.getRawValue();
    formToSendDocuments[0].forEach((element, index) => {
      this.model2['documentList'][index]['regCmpDocumentisValid'] = bool;
    });
    this.model = {...this.model};
    this.model2 = {...this.model2};
  }

  download(event, file) {
    this.gridService.downloadFile(event.value, this.userId, file).subscribe({
      next: () => {
        this.logger.log('Downloaded file');
      },
      error: () => {
        this.logger.log('Error Dowloading file');
      },
    });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setActive(index) {
    this.activedStep = index;
  }

  nextStep() {
    this.activedStep = this.activedStep + 1;
  }

  backStep() {
    this.activedStep = this.activedStep - 1;
  }
  activedStep = 0;

  
  getAuditList(){
    this.loading =true
    this.gridService.getAuditList(this.userId)
    .subscribe(
      data => {
        this.auditList = data.data;
        this.loading=false;
      },
      error => {
        this.logger.error(error);
        this.loading=false;
      }
    );
  }

}
